export {default} from './ChatEventMessage';



// WEBPACK FOOTER //
// ./src/components/ChatUI/ChatEventMessage/index.ts